const testimonialTextSlider = new Swiper('.testimonials-text', {
  slidesPerView: 1,
  loop: true,
  spaceBetween: 20,
  allowTouchMove: true,
  speed: 500,
  watchSlidesProgress: true,
  effect: 'fade',
  fadeEffect: {
    crossFade: true
  },
  navigation: {
    nextEl: '.testimonials-slider .swiper-button-next--text',
    prevEl: '.testimonials-slider .swiper-button-prev--text',
  },
  breakpoints: {
    768: {
      allowTouchMove: false,
    }
  }
});

const testimonialImageSlider = new Swiper('.testimonials-images', {
  slidesPerView: 1,
  loop: true,
  spaceBetween: 0,
  allowTouchMove: true,
  speed: 500,
  watchSlidesProgress: true,
  navigation: {
    nextEl: '.testimonials-slider .swiper-button-next--image',
    prevEl: '.testimonials-slider .swiper-button-prev--image',
  },
  breakpoints: {
    768: {
      allowTouchMove: false,
    }
  }
});

// Sync sliders
testimonialImageSlider.on('slideChange', slider => {
  let idx = slider.realIndex;

  testimonialTextSlider.slideToLoop(idx);
});

testimonialTextSlider.on('slideChange', slider => {
  let idx = slider.realIndex;

  testimonialImageSlider.slideToLoop(idx);
});